export default {
  // -----------   Common   -----------

  commonAll: 'All',
  copiedToClipboard: 'Copied to clipboard',
  commonViewAll: 'View All',
  commonXtoY: '@@1 to @@2',
  commonOverX: 'Over @@1',
  commonDate: 'Date',
  commonDateRangeTomorrow: 'Tomorrow',
  commonDateRangeOneWeek: '1 Week',
  commonDateRangeOneMonth: '1 Month',
  commonDateRangeCustomDate: 'Custom Date',
  commonDateRangePeriod: 'Period',
  commonClose: 'Close',
  commonFavourites: 'Favourites',
  commonLastPrice: 'Last Price',
  commonLastPriceShort: 'Last Price',
  commonChange: 'Change',
  commonOK: 'OK',
  commonLoadMore: 'Load more',
  commonDetails: 'Details',
  commonButtonsTryAgain: 'Try again',
  commonButtonContactSupport: 'Contact Support.',
  commonSupport: 'support',
  commonLogout: 'Log out',
  commonReturnToHomePage: 'Return to Home Page',
  commonOrderSummary: 'Order Summary',
  commonSymbol: 'Symbol',
  commonEndDate: 'End Date',
  commonContactUs: 'Contact us',
  commonCalendarDay: '@@1 Day',
  commonCalendarDays: '@@1 Days',
  commonOkay: 'Okay',
  commonOr: 'or',
  commonBack: 'Back',
  commonDays: 'days',
  commonDashboard: 'Dashboard',
  commonPlanDetails: 'Plan Details',
  commonTryAgain: 'Try Again',
  commonGreat: 'Great',
  commonWithdraw: 'Withdraw',
  commonGood: 'Good',
  commonWarning: 'Warning',
  commonCritical: 'Critical',
  commonHere: 'here',
  commonIn: 'in',

  // portals

  // Error Boundary
  commonSomethingWentWrongText: 'Ooops. Something crashed!',
  commonSomethingWentWrongButtonText: 'Try Again',

  // Request error messages
  requestErrorOver500: 'Ooops. Something crashed!',

  // Change Password

  // common preloading messages
  commonMessageLoading: 'Loading @@1...',
  commonMessageConnecting: 'Connecting ...',
  commonMessageSwitchingFundedPlan: 'Switching to Funded Plan...',
  commonMessageSwitchingDemoPlan: 'Switching to Demo Plan...',
  commonMessageConnectionTimedOut: 'Connection timed out. @@1Please check your internet connection and try again ...',
  commonMessageNoData: 'No data available.',
  commonChartNoData: 'No data available for the selected period. Try refreshing, or contact support if the problem continues.',

  // orders
  commonOrderSideButtonBuy: 'Buy',
  commonOrderSideButtonSell: 'Sell',
  commonOrderSideButtonKeepIt: 'No, keep it',
  commonOrderSideButtonKeepIt2: 'No, keep it',
  commonOrderSideButtonProceed: 'Yes, proceed',
  commonOrderSideButtonProceed2: 'Yes, proceed',

  // order status map
  commonOrderStatusPending: 'Pending',
  commonOrderStatusCompleted: 'Completed',
  commonOrderStatusCanceled: 'Cancelled',
  commonOrderStatusRejected: 'Rejected',
  commonOrderStatusFilterFilled: 'Filled',
  commonOrderStatusFilterPartiallyFilled: 'Partially Filled',
  commonOrderStatusFilterPartiallyRejected: 'Partially Rejected',
  commonOrderStatusFilterTitle: 'Status',
  commonOrderStatusFilterExpired: 'Expired',
  commonOrderStatusFilterCancelled: 'Cancelled',
  commonOrderStatusUndefined: 'Undefined',

  // order time in force map
  commonOrderTimeInForceExtendedHours: 'Extended Hours',

  // watchlist
  commonWatchlist: 'Watchlist',
  commonWatchlistChartNA: 'n/a',
  commonWatchlistRetry: 'Retry',
  symbolDetailsAddToWatchlist: 'Add to Favourites',
  symbolDetailsAddedToWatchlist: 'Added to Favourites',
  commonSymbolAddedToWatchlistMsg: '@@1 has been added to your Favourites watchlist.',
  commonSymbolRemovedToWatchlistMsg: '@@1 has been removed from your Favourites watchlist.',
  commonWatchlistFavoutesLimit: 'Add up to 15 of your favourite stocks here',
  commonWatchlistFavoutesLimitReached: 'Your favourites watchlist is already full - 15 out of 15 stocks.',

  // watchlist headers my account -> my stocks
  headerMyAccountMyStockSymbolName: 'Symbol/Name',
  headerMyAccountMyStockQuantity: 'Quantity',
  headerMyAccountMyStockPurchasePrice: 'Purchase Price',
  headerMyAccountMyStockMarketPrice: 'Market Price',
  headerMyAccountMyStockUnrealizedProfit: 'Unrealized Profit',
  headerMyAccountMyStockButtons: 'buttons',

  // watchlist headers my account -> pending orders
  headerMyAccountPendingOrderSymbolName: 'Symbol/Name',
  headerMyAccountPendingOrderDatePlaced: 'Date Placed',
  headerMyAccountPendingOrderType: 'Type',
  headerMyAccountPendingOrderQuantity: 'Quantity',
  headerMyAccountPendingOrderSetPrice: 'Set Price',
  headerMyAccountPendingOrderExpiryDate: 'Expiry Date',
  headerMyAccountPendingOrderExpiryDate2: 'Expiry Date',
  headerMyAccountPendingOrderButtons: 'buttons',

  // verification
  commonVerificationPhoneNeeded: 'Let\'s register your phone number',
  commonVerificationPhoneNeededSubtitle: 'This will further protect your account.',
  commonVerificationInputFieldMandatory: 'This field is mandatory',
  commonVerificationCountryCodeNoResults: 'No results found for @@1',

  // stock details
  commonStockDetailsStatsTitle: 'Statistics',
  commonStockDetailsStatsAvgVolume: 'Avg. Volume',
  commonStockDetailsStatsPrevClose: 'Prev. Close',
  commonStockDetailsStatsOpen: 'Open',
  commonStockDetailsStatsLow: 'Low',
  commonStockDetailsStatsHigh: 'High',
  commonStockDetailsStatsMarketCap: 'Mkt. Cap',
  commonStockDetailsStatsWeek52Low: '52Wk. Low',
  commonStockDetailsStatsWeek52High: '52Wk. High',
  commonStockDetailsStatsPE: 'P/E Ratio',
  commonStockDetailsStatsDivYield: 'Div. Yield',
  commonStockDetailsAboutCompanyTitle: 'About the company',
  commonStockDetailsAboutCompanyCeo: 'CEO',
  commonStockDetailsAboutCompanyEmployees: 'Employees',
  commonStockDetailsAboutCompanySector: 'Sector',
  commonStockDetailsAboutCompanyIndustry: 'Industry',
  commonStockDetailsAboutCompanyHeadquarters: 'Headquarters',
  commonStockDetailsStatsPeopleAlsoTradeTitle: 'People also trade',
  commonStockDetailsShowMore: 'Show more',
  commonStockDetailsShowLess: 'Show less',

  // other
  commonSearchForETFsTitle: 'ETFs',
  commonSearchForSymbol: 'Search by symbol ...',
  commonSearchForNoSymbolFound: 'No symbols found',
  commonInvalidValue: '-',
  commonContinueButton: 'Continue',
  commonContinuePaymentButton: 'Continue to Payment',
  commonContinuePlatformButton: 'Continue to Platform',
  commonCancelButton: 'Cancel',
  commonActivateButton: 'Activate',
  commonYes: 'Yes',
  commonNo: 'No',
  commonNotNow: 'Not now',
  commonGoBackBtn: 'Go Back',
  commonViewMore: 'View More',
  commonChoose: 'Choose',
  commonApply: 'Apply',

  // onboarding
  commonOnboardingInitialCountryLabel: 'Country of residence',

  // Next Steps Activation screen

  // account activation

  // Enrollment Recovery
  commonEnrollmentCreateProfileTitle: 'Create Your AceTrade Account',
  commonEnrollmentCreateProfileSubTitle: 'Specify your country of residence, as our app is available in select regions only.',
  commonEnrollmentEnterFirstName: 'Enter your first name',
  commonEnrollmentEnterLastName: 'Enter your last name',
  commonEnrollmentEnterEmail: 'Enter your email',
  commonEnrollmentEnterPassword: 'Enter your password',
  commonEnrollmentApprovePrivacyPolicy1: 'I agree that my personal data will be processed according to',
  commonEnrollmentApprovePrivacyPolicy2: 'and',
  commonEnrollmentApprovePrivacyPolicy3: 'AceTrade Privacy',
  commonEnrollmentApproveCookiesPolicy: 'Cookies Policy',
  commonEnrollmentWelcomeMessageThankYou: 'Thank you for joining AceTrade!',
  commonEnrollmentWelcomeMessageContentYourJourney: 'Your account is being set up and should be ready in a couple of minutes.  Your journey to become a Funded Trader starts soon!',
  commonEnrollmentSecurityDetails: 'Enter your security details',

  // Not Active Individual Notification

  // General Questions
  commonGeneralQuestionsTypeLabel: 'Type',

  // onboarding

  // transitions screens

  // startup screen
  commonOnboardingCarousel1Title: 'Welcome to AceTrade, @@1',
  // sign in screen (email, name etc.)
  commonOnboardingSignInEmail: 'Email',
  commonOnboardingSignInPassword: 'Password',
  commonOnboardingSignInButtonCreateAccount: 'Create account',
  commonOnboardingSignInValidation8Chart: 'Minimum 8 characters',
  commonOnboardingSignInValidationUpperCaseLetter: 'Uppercase letter',
  commonOnboardingSignInValidationLowerCaseLetter: 'Lowercase letter',
  commonOnboardingSignInValidationSpecialSymbol: 'Special symbol',
  commonOnboardingSignInValidationNumber: 'Number',

  commonPolicyAgreementErrorMessage:
    'Please indicate that you have read and agree with the Privacy Policy and Cookies Policy',

  // confirm email
  commonOnboardingEmailConfirmTitle: 'Verify your email',
  commonOnboardingEmailConfirmDescription1: 'We sent a verification email to',
  commonOnboardingEmailConfirmDescription2: 'Please tap the link inside that email to continue.',
  commonOnboardingEmailSpamDescription1: 'Haven\'t received a confirmation email',
  commonOnboardingEmailSpamDescription2: 'Check your spam folder',
  commonOnboardingEmailConfirmInvalidEmailMessage: 'Email address is invalid.',
  commonOnboardingEmailConfirmedTitle: 'Email confirmed!',
  commonOnboardingEmailConfirmedDescription1: 'Thanks for signing up!\nNow you can hop on and explore the world of 10n.',
  commonOnboardingEmailAccountHasBeenConfirmed: 'The account has been confirmed.',
  commonOnboardingEmailCompleted: 'Thanks for signing up! Now you can hop on and explore the world of AceTrade. We hope you will enjoy the ride.',

  // Expired verification modal
  commonOnboardingExpiredVerificationLinkTitle: 'The verification link has expired.',
  commonOnboardingExpiredVerificationLinkBody: 'Please sign up again or log in if you have already registered.',
  // recovery
  // phone verification
  commonOnboardinghoneCountryCode: 'Country Code',
  commonOnboardingPhoneVerificationCountry: 'Country',
  commonOnboardingPhoneVerificationPhoneNumber: 'Phone Number',
  commonOnboardingPhoneVerificationPhoneNumberVerified: 'Phone number verified',
  commonOnboardingPhoneVerificationCanContinueWithPlan: 'Now you can continue with your plan payment and start trading.',
  commonOnboardingPhoneVerificationEnterPhoneNumber: 'Enter Phone Number',
  commonOnboardingPhoneVerificationSearchCodePlaceholder: 'Search...',
  commonOnboardingPhoneVerificationSMSCodeTitle: 'Verify your phone number',
  commonOnboardingPhoneVerificationSMSCodeSubitle: 'Check your SMS messages. We\'ve sent you the code at @@1',
  commonOnboardingPhoneVerificationSMSCodeNotReceived: 'Didn\'t get anything?',
  commonOnboardingPhoneVerificationSMSCodeExpriesIn: 'Resend code in - ',
  commonOnboardingPhoneVerificationInvalidCodeLength: 'Invalid code length',
  commonOnboardingPhoneVerificationCodeSendAgainErrorMessage: 'Please try again',
  commonOnboardingPhoneVerificationCodeClientErrorMessage: 'Invalid phone number',
  commonOnboardingPhoneVerificationDuplicatePhoneNumber: 'Number already in use by another account',

  // countries
  // personal details
  commonOnboardingGenericRequiredField: 'The field',
  commonOnboardingGenericFieldIsRequired: '@@1 is required.',
  commonOnboardingPersonalDetailsFirstName: 'First Name',
  commonOnboardingPersonalDetailsLastName: 'Last Name',
  commonOnboardingPersonalDetailsDateOfBirth: 'Date of birth',
  commonOnboardingPersonalDetailsDateOfBirthErrorMessage: 'Please select a date of birth.',
  // TODO: delete this text when the mobile change is made
  commonOnboardingPersonalDetailsCountry: 'Country',
  commonOnboardingPersonalDetailsTaxDetailsTaxNumber: 'Tax number',
  commonOnboardingPersonalDetailsTaxNumberMessage:
    'Tax number is usually your national Id number. You could also check with local tax authorities for guidance.',
  commonOnboardingPersonalDetailsUnderEighteenError: 'You must be at least 18 years old to register an account.',

  // Common validations
  commonValidationTextInvalid: '@@1 is invalid.',
  commonErrorRegister1: 'An error occurred. Please',
  commonErrorRegister2: 'contact us',
  commonErrorRegister3: 'for assistance',

  // Tax Details

  // Edit Document

  // Legal declarations

  commonWelcomeToPlatform: 'Welcome to the AceTrade Platform',
  commonWelcomeToPlatformDescription: 'Choose the plan that suits your best trading interest to continue on your journey, or try a 60 Day Free demo.',
  commonWelcomeToPlatformDescription2: 'Choose the plan that suits your best trading interest to continue on your journey.',
  commonAccountSettingUpReady: 'Your account is being setup. We will let you know when it\'s ready.',
  commonDemoAccountSettingUpReady: 'Your demo account is being setup. We will let you know when it\'s ready.',
  commonAccountIsAllSet: 'Your account is all set!',
  commonAccountIsAllSetDescription: 'Your plan is now active. Just refresh the platform and start trading.',
  commonRefresh: 'Refresh',
  commonActivatingDemoAccountTitle: 'Activating Demo Account',
  commonExpiredDemoAccountTitle: 'Your demo has expired',
  commonExpiredDemoAccountDesc: 'You can still access your Demo Plan at any time and view your performance.',
  commonActivatingDemoAccountDesc: 'Try our 60-day Demo to experience Ace Trade risk-free. You can upgrade to a paid plan at any time',

  // Yay Activated

  // upload
  commonMakeSureFollowing: 'Make sure of the following:',
  commonOnboardingUploadDocumentConfirmDescription: 'Please make sure the text is clear and your entire document is visible.',

  // Verification
  commonVerificationStepStatusPending: 'Pending verification',
  commonVerificationUploadFileSizeExceededMessage: 'Maximum file size of 10mb exceeded',
  commonVerificationUploadFileWrongFormatMessage: 'Unsupported file format. Please check accepted file types',

  // Upload document
  commonUploadDocumentTypesHint: '*Accepted file types: @@1 only - up to 10mb',
  commonUploadDocumentLabel1: 'Drop your image here, or',
  commonUploadDocumentLabel2: 'browse',
  commonUploadDocumentWebLabel3: 'Your bank account',

  // discover
  commonDiscoverTitle: 'Discover',
  discoverStocks: 'Discover Stocks',

  // Discover - Calendars
  commonDiscoverCalenderEventsToday: 'Today',
  commonDiscoverCalenderItem: 'Event',
  commonDiscoverCalenderItems: 'Events',
  commonDiscoverCalenderSectionTimeBeforeMarketOpen: 'Before Open',
  commonDiscoverCalenderSectionTimeAfterMarketClose: 'After Close',
  commonDiscoverCalenderSectionTimeNotSupplied: 'Time Not Supplied',
  commonDiscoverCalendarEarningsEst: 'est',
  commonDiscoverCalendarFilterAllSymbols: 'All Symbols',
  commonDiscoverCalendarFilterBySymbol: 'Filter by Symbol',
  commonDiscoverCalendarFilterBySymbolPlaceholder: 'Filter by symbol or company name',
  commonDiscoverCalendarFilterFavoritesWatchlist: 'Favourites Watchlist',
  commonDiscoverCalendarFilterMyPortfolio: 'My Portfolio',
  commonDiscoverCalendarFilterTitle: 'Filter Symbols',
  commonDiscoverCalenderSectionNotSupplied: 'Not Supplied',
  commonDiscoverCalenderSectionTimeReported: 'Reported',
  commonNoResultsFoundFor: 'No results found for "@@1"',
  upcomingEarningsNoDataForPeriod: 'No upcoming earnings for the selected period',
  earningsReportDetailsTitle: '@@1 Earnings Report',
  earningsReportDetailsEpsEst: 'EPS Est',
  earningsReportDetailsEpsSurprise: 'EPS/Surprise',
  earningsReportDetailsPreviousReports: 'Previous reports',
  earningsReportDetailsRevenue: 'Revenue:',
  earningsReportDetailsRevenueEst: 'Revenue Est:',
  commonDiscoverCalenderSectionTimeEPSEstimate: 'EPS estimate • $@@1',
  commonDiscoverCalenderSectionTimeNoEPSEstimate: 'EPS esimtate -',

  // Discover - New on the market

  // Discover - Long term investments
  commonDiscoverSubtitleLongTermInvestments: 'Long term investments',
  commonDiscoverSubtitleLongTermInvestmentsTableHeader5: 'Volume',

  // Discover - News
  commonDiscoverNews: 'Latest news',

  // Discover - Earnings Calendar
  upcomingEarnings: 'Upcoming Earnings',
  marketCapRadarTitle: 'Market Cap Radar',
  marketCapRadarDescription: 'Scan five market cap bands for top gainers and losers, updated every minute.',
  marketCapRadarMobileMarketCap: 'Mrk Cap: @@1',
  marketCapRadarMarketCap: 'Market Cap',
  marketCapRadarPriceAndChange: 'Price/%',
  marketCapRadarVolume: 'Volume',
  marketCapRadarVolumePercentage: 'Volume %',
  marketCapRadarCategoryMegaLarge: 'Mega Cap',
  marketCapRadarCategoryLarge: 'Large Cap',
  marketCapRadarCategoryMid: 'Mid Cap',
  marketCapRadarCategorySmall: 'Small Cap',
  marketCapRadarCategoryPenny: 'Penny Stocks',
  marketCapRadarRangeMegaLarge: 'Over $50B',
  marketCapRadarRangeLarge: 'from $10B to $50B',
  marketCapRadarRangeMid: 'from $2B to $10B',
  marketCapRadarRangeSmall: 'from 300M to 2B',
  marketCapRadarRangePenny: 'from 1M to 300M',
  upcomingEarningsNoData: 'No upcoming earnings data. \n Please check back later',
  discoverEarningsCalendarTitle: 'Earnings Calendar',
  upcomingEarningsText: 'Check company earnings calendar and prepare for market changes.',

  // Discover - 52 Week Highs
  commonDiscoverDailyPercentChange: '1D %Chg',
  commonDiscover52WeekPercentChange: '52W %Chg',
  commonDiscover52WeekPercentChangeMobile: 'Daily/52wk.',
  commonDiscover52WeekNoData: 'No matches currently. Check back later',
  commonDiscover52WeekNoDataAll: 'Currently, there are no matches for this scanner. Please check back later',

  // Discover - Popular groups
  commonDiscoverSubtitlePopularGroups: 'Popular Groups',

  popularGroupCommunications: 'Communications',
  popularGroupHealthcare: 'Healthcare',
  popularGroupConsumerDiscretionary: 'Consumer Discretionary',
  popularGroupTechnology: 'Technology',
  popularGroupUtilities: 'Utilities',
  popularGroupConsumerStaples: 'Consumer Staples',
  popularGroupFinancialServices: 'Financial Services',
  popularGroupBasicMaterials: 'Basic Materials',
  popularGroupRealEstate: 'Real estate',
  popularGroupIndustrials: 'Industrials',
  popularGroupEnergy: 'Energy',
  popularGroupETFs: 'ETFs',

  // Discover - Charts - Dividend payers - High growth companies
  commonDiscoverDividendPayers: 'Dividend payers',
  commonDiscoverDividendPayersLegend: 'Dividend yield',
  commonDiscoverHighGrowthCompanies: 'Growth companies',
  commonDiscoverHighGrowthCompaniesLegend: 'Growth indicator',
  commonDiscoverInfoBoxMarketCap: 'Market Cap',
  commonDiscoverInfoBoxRevenue: 'Revenue',
  commonDiscoverInfoBoxEps: 'EPS',
  commonDiscoverInfoBoxVolume: 'Volume',
  commonDiscoverInfoBoxPrevClose: 'Prev close',
  commonDiscoverInfoBoxDividendRate: 'Dividend rate',
  commonGrowthIndicatorDescription: 'The average of Revenue growth and EPS growth for the past twelve months',

  // Market Hours
  commonMarketHoursPre: 'Pre-Market',
  commonMarketHoursAfter: 'After Hours',
  commonMarketHoursAtClose: 'At Close',
  performanceRangeTextToday: 'Today',

  // market states modal
  commonMarketHours: 'Market Hours',
  commonMarketStatePreMarket: 'Pre-Market',
  commonMarketStateOpen: 'Market Open',
  commonMarketStateAfterHours: 'After Hours',
  commonMarketStateClosed: 'Closed',
  commonTimesDisplayedLocalTime: 'Times displayed are in your local timezone',
  commonPreMarketHoursModalDescription: 'Trading is available before the main session begins. Only limited orders are accepted. Note that liquidity may be lower and spreads wider',
  commonOpenMarketHoursModalDescription: 'The main trading session is active. All order types are accepted',
  commonAfterMarketHoursModalDescription: 'Trading continues after the main session closes. Only Limit orders are accepted. Note that activity is lower and price moves may be sharper due to limited participation.',
  commonClosedMarketHoursModalDescription: 'The market is currently closed. Only Limit orders can be placed but they will be queued for execution once the respective  trading session opens',
  commonMarketHoursAtClose2: 'At Close',
  commonPreMarketHoursTradingStarting: 'Regular trading hours start in:',
  commonMarketClosedHoursTradingStarting: 'The stock market is currently closed. Pre-market starts in:',

  // Trading tickets
  commonTradingOrder: 'Order',
  commonTradingOrderType: 'Order Type',
  commonTradingOrderTypeShort: 'Order Type',
  commonTradingExpiryDate: 'Expiry Date',
  commonTradingExtendedHoursTrade: 'Extended Trading Hours',
  commonTradingOrderValue: 'Order Value',
  commonTradingOrderValue2: 'Total Value',
  commonConfirmOrderButton: 'Confirm Order',
  commonConfirmOrderButton2: 'Confirm Order',
  commonTradingPriceError: 'You should enter @@1 price for this order',
  commonTradingAggressiveLimitPriceError1: 'Buy Price must be lower than @@1',
  commonTradingShortSellDialog: 'You are about to place a Short sell order',
  commonTradingShortSellDialogDescription:
    'Short selling is an advanced form of trading. It poses additional risks and potential of losses that you should consider.',
  commonTradingShortSellDialogDescriptionWeb: 'Short selling is available during regular trading hours only.',
  commonRegularTradingShortSellDescription: 'Please be advised that a daily interest fee of @@1 will be applied',
  commonTradingNotEnoughBuyingPowerTitle: 'Not enough buying power',
  commonTradingNotEnoughBuyingPowerDescription: 'Free up funds for this trade by closing or reducing an existing position.',
  commonNotEnoughSharesAvailable: 'Please use a smaller number of shares',

  // Trading validation
  commonTradingValidationNewOrderSellAggressiveLimitError1: 'Sell Price must be higher than @@1',

  // Halted stock
  commonHaltedSymbolPopupTitle: 'Unavailable for trading',
  commonHaltedSymbolPopupContent: 'Sell and buy orders for @@1 are currently restricted due to a trading halt.',
  commonHaltedSymbolPopupContent2: 'Sell and Buy orders are currently restricted due to a trading halt',
  commonMaintenanceMessageBeforeEmail: 'Technical issues. Email orders to',
  commonMaintenanceMessageAfterEmail: 'Notification will follow when trading resumes.',

  // Inbox messages
  commonInboxNoMessagesText: 'There\'s nothing here yet.',
  commonInboxNoMessagesText2: 'No messages',
  commonInboxSelectedMessagesText: '@@1 Selected',
  commonInboxDeleteMessagesTitle: 'Delete @@1 messages',
  commonInboxAreYouSureYouWantToDeleteMessageText1: 'Are you sure you want to delete this messages?',
  commonInboxAreYouSureYouWantToDeleteMessageText2: 'This is permanent.',

  // -----------   Web   -----------

  // signUp
  webSignInEmailNotReceived: 'Haven\'t received a confirmation email? Check your spam folder or',
  webResendCode: 'Resend Code',
  webResendEmailAgain: 'Resend Email',
  webResendEmail: 'Resend email in',

  // onboarding

  // Trading
  webTradingCurrentlyAskPrice: 'Current Ask price: @@1',
  webTradingCurrentlyBidPrice: 'Current Bid price: @@1',
  webTradingDisclaimerPopover:
    'The price we show on our charts represents the last fulfilled trade on the market. This is why there might be a difference from the current market / @@1 price.',
  webTradingAskAndBidPricesGeneralInfo: 'Buy orders will execute at the best Ask price and Sell orders will execute at the best Bid price.',
  webTradingIncorrectStocks: 'Not enough available stocks. \n Please try again',
  webTradingShortedStocks: 'Shorted stocks: @@1',
  webTradingAvailableShares: 'Shares Available: @@1',
  webTradingLimit: 'limit',
  webTradingStop: 'stop',
  webTradingHighLowLimitPriceAlert: '@@1 Limit Price',
  webTradingHighLowLimitPriceAlertHigh: 'High',
  webTradingHighLowLimitPriceAlertHigher: 'higher',
  webTradingHighLowLimitPriceAlertLow: 'Low',
  webTradingHighLowLimitPriceAlertLower: 'lower',
  webTradingHighLowLimitPriceAlertDescription:
    'Your selected limit price is @@1 than the market stock price. This could lead to immediate fulfilment of your order. Would you like to continue?',
  webTradingEditPriceButton: 'Edit Price',

  // (1/7) order message - placed
  orderMessageTitlePlaced: '@@1 @@2 order placed',
  orderMessageBodyPlaced: 'Your order for @@1 x @@2 was placed',
  // (2/7) order message - filled
  orderMessageTitleFilled: '@@1 @@2 order filled',
  orderMessageBodyFilled: 'Your order for @@1 x @@2 was filled',
  orderMessageTitlePartiallyFilled: '@@1 @@2 order partially filled',
  orderMessageBodyPartiallyFilled: '@@1 / @@2 @@3 were filled',
  // (3/7) order message - being processed
  orderMessageBodyPendingWeb: 'Your @@1 @@2 order for @@3 x @@4 is being processed',
  // (4/7) order message - rejected
  orderMessageTitleRejected: '@@1 @@2 Order rejected',
  orderMessageTitlePartiallyRejectedTitle: '@@1 @@2 order partially rejected',
  orderMessageBodyPartiallyRejectedBody: '@@1 / @@2 @@3 were rejected',
  orderMessageBodyRejectedWeb: 'Your @@1 @@2 order for @@3 x @@4 was rejected',
  orderMessageExpired: 'Your @@1 @@2 order for @@3 x @@4 has expired',
  orderRejectDefault: 'Order couldn\'t be processed. If the issue persists, contact support.',
  orderRejectAccountNotRecognized: 'Account not recognized. If the issue persists, contact support',
  orderRejectOrderFailedAccountInfoMissing: 'Order failed - account info missing.',
  orderRejectOrderCouldntBeSubmitted: 'Order couldn\'t be submitted. Try again.',
  orderRejectDuplicateOrderDetected: 'Duplicate order detected. Try again',
  orderRejectOriginalOrderNotFound: 'Original order not found.',
  orderRejectSymbolNotRecognized: 'Symbol not recognized. Check and try again',
  orderRejectNoLivePriceAvailableSymbol: 'No live price available for this symbol',
  orderRejectPositionTooLargeAccount: 'Position too large for your account.',
  orderRejectPositionSizeLimitReached: 'Position size limit reached.',
  orderRejectTotalHoldingsExceedAccountLimit: 'Total holdings exceed account limit.',
  orderRejectTotalPositionLimitReached: 'Total position limit reached.',
  orderRejectOrderTooLargeAccount: 'Order too large for your account.',
  orderRejectOrderSizeLimitReached: 'Order size limit reached.',
  orderRejectOpenOrdersExceedAccountLimit: 'Open orders exceed account limit.',
  orderRejectOrderExceedsAvailableMargin: 'Order exceeds available margin.',
  orderRejectTotalOpenOrdersLimitReached: 'Total open orders limit reached.',
  orderRejectPositionOrderSizeTooLargeAccount: 'Position / order size too large for your account.',
  orderRejectCombinedPositionOrderLimitReached: 'Combined position/order limit reached.',
  orderRejectPositionsOpenOrdersExceedAccountLimit: 'Positions / open orders exceed account limit.',
  orderRejectPositionsOpenOrdersLimitReached: 'Positions / open orders limit reached.',
  orderRejectDailyLossLimitReached: 'Daily loss limit reached.',
  orderRejectMaxLossLimitReached: 'Max loss limit reached.',
  orderRejectLossLimitReachedSymbol: 'Loss limit reached for this symbol',
  orderRejectPositionValueLimitReached: 'Position value limit reached.',
  orderRejectNotEnoughBuyingPower: 'Not enough buying power.',
  orderRejectPositionLimitReached: 'Position limit reached.',
  orderRejectOrderSizeTooLarge: 'Order size too large.',
  orderRejectOrderValueTooLarge: 'Order value too large.',
  orderRejectPriceTooFarFromMarket: 'Price too far from market.',
  orderRejectPriceBelowMinimumAllowed: 'Price below minimum allowed.',
  orderRejectPriceAboveMaximumAllowed: 'Price above maximum allowed.',
  orderRejectOddLotSizesNotAllowed: 'Odd lot sizes not allowed.',
  orderRejectInsufficientBuyingPowerSymbol: 'Insufficient buying power for this symbol',
  orderRejectQuantityLimitReachedSymbol: 'Quantity limit reached for this symbol',
  orderRejectShortSellingRestrictedSymbol: 'Short selling restricted for this symbol',
  orderRejectSymbolRestricted: 'This symbol is restricted.',
  orderRejectShortSellingNotAllowedAccount: 'Short selling not allowed on this account.',
  orderRejectTradingCurrentlyDisabled: 'Trading is currently disabled.',
  orderRejectShortSellingDisabledAccount: 'Short selling disabled on this account.',
  orderRejectAccountRestrictedClosingPositionsOnly: 'Account restricted to closing positions only.',
  orderRejectAccountOrSessionDisabled: 'Account or session disabled.',
  orderRejectOrderTypeMismatchSellShort: 'Order type mismatch - check sell/short.',
  orderRejectNoSharesAvailableBorrowShort: 'No shares available to borrow for short.',
  orderRejectOrderTooLargeTradingVolume: 'Order too large vs. trading volume.',
  orderRejectYoureNotEntitledTradeSymbol: 'You\'re not entitled to trade this symbol',
  orderRejectDuplicateOrderNotPlaced: 'Duplicate order - not placed.',
  orderRejectOrderTypeIsntSupported: 'This order type isn\'t supported.',
  orderRejectOrderDetailsInvalid: 'Order details invalid. If the issue persists, contact support',
  orderRejectOrderAlreadyClosed: 'This order is already closed.',
  orderRejectOrderChangeAlreadyInProgress: 'Order change already in progress.',
  orderRejectMarketOrdersArentAllowed: 'Market orders aren\'t allowed.',
  orderRejectShortExemptOrdersNotAllowed: 'Short-exempt orders not allowed.',
  orderRejectMarketOpenOrdersNotAllowed: 'Market-on-Open orders not allowed.',
  orderRejectLimitOpenOrdersNotAllowed: 'Limit-on-Open orders not allowed.',
  orderRejectOrderTypeIsntAllowed: 'This order type isn\'t allowed.',
  orderRejectImmediateOrCancelOrdersNotAllowed: 'Immediate-or-Cancel orders not allowed.',
  orderRejectGoodTillCancelledOrdersNotAllowed: 'Good-Till-Cancelled orders not allowed.',
  orderRejectGoodTillDateOrdersNotAllowed: 'Good-Till-Date orders not allowed.',
  orderRejectMarketCloseBlockedRegulatory: 'Market-on-Close blocked (regulatory).',
  orderRejectMarketCloseOrdersNotAllowed: 'Market-on-Close orders not allowed.',
  orderRejectLimitCloseBlockedRegulatory: 'Limit-on-Close blocked (regulatory).',
  orderRejectLimitCloseOrdersNotAllowed: 'Limit-on-Close orders not allowed.',
  orderRejectOrderBlockedPossibleWashSale: 'Order blocked - possible wash sale.',
  orderRejectTradingVolumeTooLowOrder: 'Trading volume too low for this order.',
  orderRejectOrdersTooLargeDailyVolume: 'Orders too large vs. daily volume.',
  orderRejectTradesTooLargeDailyVolume: 'Trades too large vs. daily volume.',
  orderRejectTooManyActivePriceLevels: 'Too many active price levels.',
  orderRejectTooManyPriceLevelsAtExchange: 'Too many price levels at this exchange.',
  orderRejectTooManyOpenOrdersActive: 'Too many open orders active.',
  orderRejectTooManyOpenOrdersAtExchange: 'Too many open orders at this exchange.',
  orderRejectPleaseWaitBeforeCancellingOrder: 'Please wait before cancelling this order.',
  orderRejectPriceOutsideAllowedRange: 'Price outside allowed range.',
  orderRejectMocOrderQuantityTooLarge: 'MOC order quantity too large.',
  orderRejectMocOrderValueTooLarge: 'MOC order value too large.',
  orderRejectOddLotOrderLimitReached: 'Odd lot order limit reached.',
  orderRejectBlockedDueRegulatoryRestriction: 'Blocked due to regulatory restriction.',
  // (5/7) order message - error
  orderMessageTitleError: 'Unable to place your order for @@1 x @@2',
  // (6/7) order message - modify
  orderMessageTitleModify: 'Modify @@1 @@2 @@3 order',
  orderMessageTitleModify2: 'Modify @@1 @@2 @@3 order',
  orderMessageModifySuccessWeb: 'Your @@1 @@2 order for @@3 x @@4 was modified',
  orderMessageBodyModifyPending2: 'Your request to modify @@1 x @@2 is being processed',
  orderMessageBodyModifyFail: 'Order modification failed',
  // (7/7) order message - cancel
  orderMessageTitleCancel: 'Cancel @@1 @@2 order',
  orderMessageCancelSuccessWeb: 'Your @@1 @@2 order for @@3 x @@4 was cancelled',
  orderMessageCancelSuccessTitle: 'Cancel @@1 @@2 order',
  orderMessageCancelSuccessBody: 'Your @@1 X @@2 order was cancelled',
  orderMessageBodyCancelPending: 'Your order for @@1 x @@2 was cancelled',
  orderMessageBodyCancelFail: 'Cancel Order request failed.',

  // order popup
  webOrderPopupCancelTitleLower: 'Cancel order',
  webOrderPopupAreYouSureToCancelLabel: 'Are you sure you want to cancel your order?',
  webPopupBankDetailsDescription1: 'Verification may take up to 3 business days.',
  webPopupBankDetailsDescription2: 'You can proceed with your deposit comfortably.',
  orderPopupFailResultSubTitle: 'Please try again.',

  // ETF Trading restrictions
  // -----------   Mobile   -----------

  mobileAddBankAccTitle: 'Add your bank account',
  mobileAddBankAccSubtitle: 'To verify your account we also need a copy of a recent bank statement',
  mobileAddBankAccInputBank: 'Bank name',
  mobileAddBankAccPlaceholderBank: 'Enter your bank name',
  mobileAddBankAccInputBankCountry: 'Bank Country',
  mobileAddBankAccInputBicSwift: 'Bic / Swift Code',
  mobileAddBankAccPlaceholderBicSwift: 'Enter your IBAN or Account',
  mobileAddBankAccInputIBAN: 'IBAN / Account',
  mobileAddBankAccPlaceholderIBAN: 'Enter BIC/SWIFT Code',
  mobileAddBankAccInputCurrency: 'Currency',
  mobileAddBankAccUploadBankStatementBtn: 'Upload bank statement',

  fundScreenActiveStatus: 'Active',
  walletSellBySymbol: 'Sell @@1',
  walletBuyBySymbol: 'Buy @@1',
  walletNoActiveAccountPleaseContact: 'Funds withdrawals from your account are currently not available. Please contact ',
  walletWithdrawalsRestricted: 'Withdrawals Restricted',
  fundScreenInActiveStatus: 'Inactive',
  fundScreenTransfer: 'Transfer',
  fundScreenAdjustment: 'Adjustment',
  fundScreenEWallet: 'eWallet',
  fundScreenCardTransfer: 'Card Transfer',
  fundScreenInternalTransfer: 'Internal Transfer',
  fundScreenAdjustmentShortMargin: 'Short Margin Interest',
  fundScreenAdjustmentOvernightBorrow: 'Overnight Borrow',
  fundScreenAdjustmentStockLocate: 'Stock Locate',
  fundScreenAdjustmentMarketData: 'Market Data',
  fundScreenAdjustmentInvoice: 'Invoice',
  mobileFundsScreenViewAllBtn: 'View All',
  mobileFundsScreenAddBankAccModalBtn: 'Add bank account',
  mobileFundsScreenAddCryptoAccModalBtn: 'Add crypto wallet',
  mobileFundsScreenFailedCardDepositDialog: 'Something went wrong',

  mobileTransactionTypeToBankAccountHeading: 'To Bank Account',
  mobileTransactionTypeToCryptoAccountHeading: 'To Crypto Wallet',
  mobileTransactionTypeFromBankAccountHeading: 'From Bank Account',
  mobileTransactionTypeLabelPaymentRef: 'Payment reference',
  mobileTransactionTypeLabelBank: 'Bank',
  mobileTransactionTypeLabelCrypto: 'Wallet',
  mobileTransactionTypeLabelAccountN: 'Account No',
  mobileTransactionTypeLabelCategory: 'Category',
  mobileTransactionTypeLabeLCryptoRate: 'Rate (@@1/@@2)',

  mobileWithdrawScreenTitle: 'Withdrawal',
  mobileWithdrawScreenSubtitle: 'Your bank may charge you for currency conversion and transfer fees',
  mobileWithdrawCryptoScreenSubtitle: 'Crypto wallet transfer fees apply',
  mobileWithdrawScreenRequestBtn: 'Request withdrawal',
  mobileWithdrawScreenModalTitle: 'Withdrawal Request',
  mobileWithdrawScreenModal:
    'Withdrawal requests are processed within 1 business day.\n\n Depending on your bank transfers may take up to 5 business days.',
  mobileWithdrawScreenInfoModalTitle: 'Available cash: @@1',
  mobileWithdrawScreenInfoModalDescription:
    'The available cash for withdrawal is calculated at the end of each day. It depends on unrealized profits, current orders and account cash transfers.',
  mobileWithdrawScreenBankAccount: 'Bank account',
  mobileWithdrawScreenCryptoWallet: 'Crypto Wallet',
  cryptoWithdrawModalTitle: 'Withdrawal request has been received',
  cryptoWithdrawModalDescription: 'Your request for @@1 has been placed and is expected to be fulfilled on the next payout day.',

  // Deposit Notifications
  mobileNameAndAddressVisible: 'Your full name, address and bank name must be clearly visible',
  mobileBankStatementIssuedLastThreeMonths: 'Bank statement issued within the last 3 months',

  mobileBankDetailsSetTitle: 'Bank details have been set!',
  mobileBankDetailsSetSubtitle1: 'Verification may take up to 3 business days.',
  mobileBankDetailsSetSubtitle2: 'You can proceed with your',
  mobileBankDetailsSetSubtitle3: 'deposits comfortably.',

  mobileDepositAmountLabel: 'Amount',

  mobileChangePasswordModalText: 'Are you sure you want to change your password?',

  mobilePasswordChangeEmailTitle: 'Check your email',
  mobilePasswordChangeEmailUnderlineHeading1: 'We\'ve just sent an email to ',
  mobilePasswordChangeEmailUnderlineHeading2: ' with password reset instructions',

  mobileWatchlistStocks: 'Popular',
  mobileSortButton: 'Sort by',

  // splash screen

  // Passcode dialog

  // order create
  mobileOrderCreateTabMarket: 'Market',
  mobileOrderCreateTabLimit: 'Limit',
  mobileOrderCreateTabStop: 'Stop',
  mobileOrderCreateTabStopLimit: 'Stop Limit',
  mobileOrderCreateTabPegged: 'Pegged',
  mobileOrderCreateButtonReviewOrder: 'Review Order',
  mobileOrderCreateBuyingPower: 'Buying Power',
  // order review
  // order popup
  mobileOrderPopupOrderSatus: 'Order @@1',
  // view orders
  // order details

  // portfolio
  mobilePortfolioTitle: 'Portfolio',

  // account
  commonSwitchToDemo: 'Switch to Demo',
  commonSwitchToFunded: 'Switch to Funded',

  // Trade History
  commonTradeHistoryNothingHere: 'There\'s nothing here',
  commonTradeHistoryDetailsPrice: '@@1 price',

  // profile
  mobileProfileHeaderTitle: 'Profile',
  mobileProfileVersion: 'Version',
  mobileProfileBuild: 'build',
  mobileProfilePersonalDetails: 'Personal details',
  mobileProfileChangePassword: 'Change password',

  // New Profile

  // tips & notifications

  // inbox

  // charts
  mobileChartInterval: '1D,1W,1M,3M,1Y,5Y',

  // set passcode

  // onboarding
  mobileOnboardingLogIn: 'Log In',
  mobileOnboardingAlreadyHaveAccount: 'You already have account?',
  mobileOnboardingUploadConfirmTitle: 'Is this clear enough?',
  mobileOnboardingUploadRetakeButton: 'Take a new photo',
  mobileOnboardTextIsClear: 'It is clear',

  // news
  newsNotFoundMessage: 'No news found. Check back soon for updates!',

  // stock search
  mobileStocksLabel: 'Stocks',
  mobileNoStocksFound: 'No stocks found',
  commonNoETFsFound: 'No ETFs found',
  mobileStockSearchHint: 'Search for stocks...',
  mobileStockSearchDescription: 'Search by symbol or company name',

  // industry search
  mobileIndustrySearchPlaceholder: 'Search...',

  // watchlist when not activated

  // Top Gainers and Losers, Movers
  commonEpicMoversToday: 'Epic Movers',
  commonEpicMoversDescription: 'Stocks with the biggest current prices change in their price bracket.',
  commonTopGainersAndLosersMarketCap: 'Market Cap',
  commonEpicMoversGainers: 'Gainers',
  commonEpicMoversLosers: 'Losers',
  commonEpicMoversLastPriceChanges: 'Last Price / %Change',
  commonEpicMoversDaily52Wk: 'Daily / 52Wk.',
  commonEpicMoversSymbolName: 'Symbol / Name',
  commonWeek52GainersAndLosers: '52-Week Gainers & Losers',
  commonWeek52GainersAndLosersStockMakingHighLow: 'Stocks making a new 52-week High or Low',

  // Trading tickets
  commonTradingOrderTitle: '@@1 @@2 Order',
  mobileTradingTicketSelectOrderType: 'Select Order Type',
  mobileTradingTicketNumberOfShares: 'Number of Shares',
  mobileTradingTicketMarketPrice: 'Market Price',
  mobileTradingTicketLimitPrice: 'Limit Price',
  mobileTradingTicketStopPrice: 'Stop Price',
  mobileTradingTicketStopPrice2: 'Stop Price',
  mobileTradingTicketExecutedAtBestAvailablePrice: 'Executed at the best available price',
  mobileTradingTicketExecutedAtLimitPriceOrLover: 'Executed at limit price or better',
  mobileTradingTicketExecutedWhenStopPriceIsReached: 'Executed when stop price is reached',
  mobileTradingTicketDateOfExpireTitle: 'Set Expiry Date',
  mobileTradingTicketDateOfExpireEndOfDayShort: 'End of Day',
  mobileTradingTicketDateOfExpireGoodTillCancelledShort: 'Good till Cancelled',
  mobileTradingTicketDateOfExpireGoodTillDate: 'Good till Date',

  commonTradeHistoryTitle: 'Trade History',
  tradingMarketLastTradePrice: 'Market Price / Last trade price: @@1',

  // Stock screen

  // Shares Owned
  commonSharesOwned: 'Shares Owned',
  commonShort: 'Short',
  commonViewHistory: 'View History',
  commonTitleHistory: 'Trade History',
  commonYouHaveTraded: 'You\'ve traded this stock in the past 90 days.',
  commonNA: 'N/A',

  // Pending Orders
  commonPendingOrders: 'Pending Orders',

  // Order summary
  commonOrderNo: 'Order No',
  commonOrderDate: 'Order Date',
  commonBoughtShares: 'Bought Shares',
  commonSoldShares: 'Sold Shares',
  commonPAndL: 'P&L',
  commonRegulatoryFees: 'Regulatory Fees',
  commonViewDetailedReport: 'View detailed report',
  commonModify: 'Modify',
  commonChart: 'Chart',
  commonPercentChange: '%Change',

  commonRegulatoryFeesMessageFINRA: 'FINRA Fee (TAF): @@1',
  commonRegulatoryFeesMessageFINRADesc: '@@1 per every stock sale',
  commonRegulatoryFeesMessageSEC: 'SEC Fee: @@1',
  commonRegulatoryFeesMessageSECDesc: '@@1 for every sale worth of $1,000',
  commonRegulatoryFeesMessageTotal: 'Total: @@1',

  // My Position

  // My Account
  commonMyAccountNoStocks: 'No stocks yet.',
  commonMyAccountNoOrders: 'No orders yet.',
  commonMyAccountNoStocksMessage: 'Go explore the world of trading and discover the stocks for you',

  commonMyAccountButtonMyStocks: 'My Stocks',
  commonMyAccountButtonPendingOrders: 'Pending orders',
  commonMyAccountPendingOrdersPartiallFill: 'Partial Fill',
  commonMyAccountPendingOrdersPartialReject: 'Partial Reject',
  commonMyAccountPendingOrdersExtHours: 'Ext. Hours',

  commonShortSell: 'Short Sell',
  commonShortSell2: 'Short Sell',
  commonAccountBreakdownTotal: 'Total',
  commonAccountBreakdownLong: 'Long',

  // headers account breakdown
  headerAccountBreakdownSymbolName: 'Symbol/Name',
  headerAccountBreakdownQuantity: 'Quantity',
  headerAccountBreakdownOpenValue: 'Open Value',
  headerAccountBreakdownMarketValue: 'Market Value',

  // headers earnings calendar
  headerEarningsCalendarEarningsCallTime: 'Earnings Call Time',
  headerEarningsCalendarEarningsPrevEPS: 'Prev EPS',
  headerEarningsCalendarEarningsEPSEstimate: 'EPS estimate',
  headerEarningsCalendarEarningsEpsSurpriseEst: 'EPS (surprise/est)',
  headerEarningsCalendarEarningsEPSEstimateMobile: 'EPS est.',
  headerEarningsEventTime: 'Event Time',
  headerEarningsEPS: 'EPS',
  headerEarningsSurprise: 'Surprise',
  headerEarningsCalendarEarningsEPSEst: 'EPS est.',

  // headers trade history
  headerTradeHistoryFillPrice: 'Fill Price',
  headerTradeHistoryAmount: 'Amount',

  // Buttons account breakdown table
  accountBreakdownTableStockLabel: 'stocks',

  // Inbox
  commonInboxTitle: 'Inbox',
  commonInboxMarkAllAsRead: 'Mark all as read',

  // Documents
  commonClientAgreement: 'Client Agreement',
  commonGeneralTermsAndConditions: 'General Terms and Conditions',

  // Notification Settings

  // My Profile / Personal Details
  commonNames: 'Names',
  commonEditNamesMultiple: 'Edit',
  commonCancelMultiple: 'Cancel',
  commonMiddleName: 'Middle Name',

  // Account Deletion

  // PEP Questions

  // Common validations
  validationMessageInvalidCharacters: '@@1 contains invalid characters',
  validationMessageMinCharacters: '@@1 should be at least @@2 characters',
  validationMessageMaxCharacters: '@@1 should be no more than @@2 characters',
  validationMessageStartWithInvalidChar: '@@1 starts with invalid character',
  validationCapitalMinimumSymbols: 'Minimum symbol count @@1',
  validationCapitalMaximumSymbols: 'Maximum symbol count @@1',
  validationCapitalInvalidNumber: 'Invalid number',
  validationInputIsMandatory: 'Field is mandatory',

  // My Account - net income cmponents chart

  // Date range error message
  dateRangeEighteenYearsMessage: 'You must be at least 18 years old',

  // Symbol details screen
  positionAverageOpenPrice: 'Average open price',
  positionAUnrealisedProfitValue: 'Unrealised profit (USD)',
  positionAUnrealisedProfitPercent: 'Unrealised profit (%)',

  // MyProfile mobile screen
  myProfilePersonalDetails: 'Personal Details',
  myProfileReports: 'Reports',
  myProfileDocuments: 'Documents',
  myProfileHelpCenter: 'Help Center',
  myProfileLogout: 'Logout',

  // Trading View Chart
  tradingViewChartLabel: 'Adv. Chart',

  // Ace Login Page:
  aceLoginTitle1: 'Choose your targets, get up to $250,000 capital and Start Trading!',
  aceLoginTitle2: 'Join a community of over 300 professional traders and strive to become a Senior Trader',
  aceLoginTitle3: 'Get up to 70% split on profits from trading 3000+ US stocks with no PDT Rule',

  // Hammer ETFs

  // Hammer Activation box

  // Reports

  adjustments: 'Adjustments Report',
  category: 'Category',
  comment: 'Comment',

  destination: 'Destination: @@1',

  // Report table headers
  cashHeader: 'Cash',
  unrealizedPnlHeader: 'Unrealized PnL',
  depositsHeader: 'Deposit',
  typeHeader: 'Type',

  // Gappers
  gapperAboveClose: 'Above Prev Close',
  gapperBelowClose: 'Below Prev Close',
  gapperInfo: 'Stocks with more than 5% price change at Market open today',
  gappersTitle: 'Gap Tracker',
  gappersTitleGapUp: 'Gap Up',
  gappersTitleGapDown: 'Gap Down',
  gappersTrackEveryStock: 'Track every stock making a big move',
  gappersHottestMoversOpenTimer: 'See the hottest stocks right at the Open in:',

  // FX

  // SymbolDetails tabs
  symbolDetailsTabOverview: 'Overview',
  symbolDetailsTabNews: 'News',
  symbolDetailsTabFinancials: 'Financials',
  symbolDetailsTabRatios: 'Ratios',

  financialsIncomeStatement: 'Income Statement',
  financialsBalanceSheet: 'Balance Sheet',
  financialsCashFlow: 'Cash Flow',

  financialsQuarterlyOption: 'Quarterly',
  financialsAnnualOption: 'Annual',

  financialsOperating: 'Operating',
  financialsInvesting: 'Investing',
  financialsFinancing: 'Financing',

  balanceSheetTotalAssets: 'Total Assets',
  balanceSheetTotalCurrentAssets: 'Current Assets',
  balanceSheetCashAndShortTermInvestments: 'Cash & Short-Term Investments',
  balanceSheetCashAndCashEquivalents: 'Cash & Equivalents',
  balanceSheetShortTermInvestments: 'Short-Term Investments',
  balanceSheetNetReceivables: 'Receivables',
  balanceSheetInventory: 'Inventory',
  balanceSheetOtherCurrentAssets: 'Other Current Assets',
  balanceSheetTotalNonCurrentAssets: 'Long-Term Assets',
  balanceSheetPropertyPlantEquipmentNet: 'Property, Plant & Equipment Net',
  balanceSheetLongTermInvestments: 'Long-term Investments',
  balanceSheetGoodwillAndIntangibleAssets: 'Goodwill & Intangibles',
  balanceSheetGoodwill: 'Goodwill',
  balanceSheetIntangibleAssets: 'Intangible Assets',
  balanceSheetTaxAssets: 'Tax Assets',
  balanceSheetOtherNonCurrentAssets: 'Other Long-Term assets',
  balanceSheetOtherAssets: 'Other Assets',

  balanceSheetTotalLiabilities: 'Total Liabilities',
  balanceSheetTotalCurrentLiabilities: 'Current Liabilities',
  balanceSheetAccountPayables: 'Accounts Payable',
  balanceSheetShortTermDebt: 'Short-term Debt',
  balanceSheetTaxPayables: 'Tax Payables',
  balanceSheetDeferredRevenue: 'Deferred Revenue',
  balanceSheetOtherCurrentLiabilities: 'Other Current Liabilities',
  balanceSheetTotalNonCurrentLiabilities: 'Long-term Liabilities',
  balanceSheetLongTermDebt: 'Long-term Debt',
  balanceSheetDeferredRevenueNonCurrent: 'Deferred Revenue',
  balanceSheetDeferredTaxLiabilitiesNonCurrent: 'Deferred Tax Liabilities',
  balanceSheetOtherNonCurrentLiabilities: 'Other Non-current Liabilities',
  balanceSheetOtherLiabilities: 'Other Liabilities',

  balanceSheetTotalStockholdersEquity: 'Total Equity',
  balanceSheetCommonStock: 'Common Stock',
  balanceSheetPreferredStock: 'Preferred Stock',
  balanceSheetRetainedEarnings: 'Retained Earnings',
  balanceSheetAccumulatedOtherComprehensiveIncomeLoss: 'Accumulated Other Comprehensive Income/Loss',
  balanceSheetOtherTotalStockholdersEquity: 'Other Stockholders Equity',

  balanceSheetTotalLiabilitiesAndStockholdersEquity: 'Total Liabilities & Stockholders Equity',
  balanceSheetTotalInvestments: 'Total Investments',
  balanceSheetTotalDebt: 'Total Debt',
  balanceSheetNetDebt: 'Total Net',

  incomeRevenue: 'Revenue',
  incomeCostOfRevenue: 'Cost of Revenue',
  incomeGrossProfit: 'Gross Profit',
  incomeOperatingExpenses: 'Operating Expenses',
  incomeResearchAndDevelopmentExpenses: 'Research & Development',
  incomeSellingGeneralAndAdministrativeExpenses: 'Selling, General & Administrative',
  incomeOperatingIncome: 'Operating Income',
  incomeTotalOtherIncomeExpensesNet: 'Total Other Income Expense',
  incomeIncomeBeforeTax: 'Income Before Tax',
  incomeIncomeTaxExpense: 'Income Tax Expense',
  incomeNetIncome: 'Net Income',
  incomeEps: 'Basic EPS',
  incomeEpsDiluted: 'Diluted EPS',
  incomeWeightedAverageShsOut: 'Weighted Average Shares',
  incomeWeightedAverageShsOutDil: 'Diluted Weighted Average Shares',
  incomeInterestIncome: 'Interest Income',
  incomeInterestExpense: 'Interest Expense',
  incomeEbitda: 'EBITDA',

  cashFlowOperatingCashFlow: 'Operating Cash Flow',
  cashFlowNetIncome: 'Net Income',
  cashFlowDepreciationAndAmortization: 'Depreciation & Amortization',
  cashFlowDeferredIncomeTax: 'Deferred Income Tax',
  cashFlowStockBasedCompensation: 'Stock Based Compensation',
  cashFlowChangeInWorkingCapital: 'Change in Working Capital',
  cashFlowAccountsReceivables: 'Change in Accounts Receivable',
  cashFlowInventory: 'Change in Inventory',
  cashFlowAccountsPayables: 'Change in Accounts Payables',
  cashFlowOtherWorkingCapital: 'Other Working Capital',
  cashFlowOtherNonCashItems: 'Other NonCash Items',

  cashFlowNetCashUsedForInvestingActivities: 'Investing Cash Flow',
  cashFlowInvestmentsInPropertyPlantAndEquipment: 'Investments in PPE',
  cashFlowAcquisitionsNet: 'Acquisitions Net',
  cashFlowSalesMaturitiesOfInvestments: 'Sale of Investments',
  cashFlowPurchasesOfInvestments: 'Purchase of Investments',
  cashFlowOtherInvestingActivities: 'Other Investing Activities',

  cashFlowNetCashUsedProvidedByFinancingActivities: 'Financing Cash Flow',
  cashFlowDebtRepayment: 'Debt Repayment',
  cashFlowCommonStockRepurchased: 'Common Stock Repurchased',
  cashFlowDividendsPaid: 'Dividends Paid',
  cashFlowOtherFinancingActivities: 'Other Financing Activities',

  cashFlowCashAtEndOfPeriod: 'End Cash Position',
  cashFlowNetChangeInCash: 'Changes in Cash',
  cashFlowCashAtBeginningOfPeriod: 'Beginning Cash Position',
  cashFlowCapitalExpenditure: 'Capital Expenditure',
  cashFlowFreeCashFlow: 'Free Cash Flow',

  // my-portal internal transfer

  // Ratios tab
  ratiosCompany: 'Company',
  ratiosSector: 'Sector',
  ratiosShowMoreButton: 'Show More',
  ratiosShowLessButton: 'Show Less',
  ratiosModalSelectYear: 'Select a Year',
  ratiosModalSelectQuarter: 'Select a Quarter',
  ratiosModalSelectPeriod: 'Select a Period',

  // Ratios Profitability
  ratiosProfitability: 'Profitability',
  ratiosGrossMargin: 'Gross Margin',
  ratiosOperatingMargin: 'Operating Margin',
  ratiosNetProfitMargin: 'Net Profit Margin',
  ratiosNetIncome: 'Net Income Per Share',
  ratiosBookValuePerShare: 'Book Value Per Share',
  ratiosReturnOnAssets: 'Return on Asset (ROA)',
  ratiosReturnOnEquity: 'Return on Equity (ROE)',
  ratiosReturnOnInvestedCapital: 'Return on Invested Capital (ROIC)',
  ratiosDividendPayoutRatio: 'Dividend Payout Ratio',
  ratiosDividendYield: 'Dividend Yield',
  ratiosEarningsPerShare: 'Earnings Per Share (EPS)',

  // Liquidity & Solvency
  ratiosLiquidityAndSolvency: 'Liquidity & Solvency',
  ratiosCurrentRatio: 'Current Ratio',
  ratiosQuickRatio: 'Quick Ratio',
  ratiosCashRatio: 'Cash Ratio',
  ratiosDaysOfSales: 'Days of Sales Outstanding',
  ratiosDeptToEquity: 'Dept to Equity',
  ratiosInterestCoverageRatio: 'Interest Coverage Ratio',
  ratiosCashFlowToDebtRatio: 'Cash Flow to Debt Ratio',

  // Valuation
  ratiosValuation: 'Valuation',
  ratiosPriceToBookRatio: 'Price to Book Ratio',
  ratiosPriceToSalesRatio: 'Price to Sales Ratio',
  ratiosPriceToEarningsRatio: 'Price to Earnings Ratio',
  ratiosPriceToFreeCashFlowRatio: 'Price to Free Cash Flow Ratio',
  ratiosEnterpriseValueToEbitda: 'Enterprise Value to EBITDA',
  ratiosEvToFreeCashFlow: 'EV to Free Cash Flow',
  ratiosPriceEarningsratio: 'Price Earnings to Growth Ratio (PEG)',

  // ACE - Producs page
  commonSelectPlan: 'Choose a Plan',
  profitTarget: 'Profit Target',
  profitLoss: 'Profit / Loss',
  payoutSplit: 'Payout Split',
  dailyLossLimit: 'Daily Loss',
  planOneTimeFee: 'One time fee',
  planPaymentErrorLostConnection: 'The connection to the server was lost. Please try again.',
  profitTargetToolTipText: 'Realized profit required to hit your target. The objective will not be considered met until all positions are closed, as open negative PnL may offset your gains.',
  tradingPlanResetDailyLossBtn: 'Rewind Daily Loss',
  tradingPlanResetDailyLossDesc: 'Keep in mind that all your positions will be closed and your buying power will be renewed. Your daily loss won\'t be added to your max loss',
  tradingPlanResetDailyLossConfirmBtn: 'Reset for @@1',
  tradingPlanDailyLossReachedTitle: 'Daily loss limit reached',
  tradingPlanDailyLossReachedPositionsClosed: 'All your positions have been closed and trading will be unavailable until the next regular market session. Accumulated daily loss has been added to your Max Drawdown.',
  tradingPlanDailyLossReachedRewindPrompt: 'If you want to reset your losses and continue trading rewind the daily loss',
  tradingPlanDailyLossReachedDesc: "Have in mind that your positions will be closed and trading won't be available till the next trading day. Your daily loss will be added to your Max loss unless you choose to reset it.",
  tradingPlanDailyLossReachedNonChallengeDesc: "Have in mind that your positions will be closed and trading won't be available till the next trading day. Your daily loss will be added to your Max loss.",
  dailyLossLimit2: 'Daily Loss limit at @@1%',
  dailyLossLimit50PercentDescription: 'Should it keep rising you might want to reset your daily limit in order to keep trading.',
  dailyLossLimit50PercentNonChallengeDescription: 'Warning: Approaching daily loss limit. Further losses might trigger a trading halt for the day.',
  dailyLossLimit75PercentDescription: 'Once its limit is reached, your positions will be closed and trades won\'t be allowed until the next trading day. Extend your limit to continue trading.',
  dailyLossLimit75PercentNonChallengeDescription: 'Once its limit is reached, your positions will be closed and trades won\'t be allowed until the next trading day.',
  maxDrawdownReached: 'Max Drawdown Reached',
  tryAgainAndSelectNewPlan: 'You almost had it! This time luck was not on your side, but you can always try again and select a new plan!',
  choosePlanAndTryAgain: 'Choose a Plan and Try Again',
  challengePassed: 'Challenge passed! You\'re one step away from getting funded.',
  challengePassedDescription: 'You\'ve hit your targets. We\'ll email you a checklist of the documents needed to complete your onboarding within one trading day. Once verified, your funded account will be activated',
  nextStageReached: 'Hurrah! Next stage reached!',
  nextStageReachedDescription: 'Your journey has just got a boost with more capital and better payouts. Keep pushing to claim the ultimate profit split',
  documentsAfterChallengeIsPassed: 'You did it! You are a Funded Trader now!',
  documentsAfterChallengeIsPassedDescription: 'You are all set and ready to trade. Crush those targets and grow your profits. Bigger payouts await ahead.',

  entryPrice: '$@@1 Entry',

  // Capital Username enroll:

  // ACE - Stripe fail urls
  proceedWithoutPaymentQuestion: 'Are you sure you want to proceed without payment?',
  proceedToPlatform: 'Yes, proceed to platform',
  tryPaymentAgain: 'Go back to payment',
  tryADemo: 'Try a Free Demo',
  payamentMethodTitle: 'Select your payment method',
  payamentMethodSubtitle: 'Choose how you\'d like to pay and get started right away.',
  payamentMethodCreditCardDesc: 'Fast, secure payments with your credit or debit card',
  paymentMethodCrypto: 'Crypto Payment',
  paymentMethodCryptoDesc: 'Pay instantly In USDT via Solana network',
  paymentMethodBirthdateTitle: 'Verify your age',
  paymentMethodBirthdateDescription: 'We need your date of birth to comply with financial regulations for crypto payments.',
  paymentMethodBirthdateSubmitError: 'We couldn\'t save your date of birth. Please try again.',
  payamentMethodAgreementText1: 'I have read and agree with the Plan ',
  payamentMethodAgreementText2: 'Terms and Conditions',
  payamentMethodContinueWithoutPayment: 'Continue without payment?',
  payamentMethodCancellingPayment: 'You are about to cancel your payment',
  payamentMethodContinueWithoutPaymentDesc: 'You\'re about to access the platform with limited features. To start your journey as a trader consider selecting your plan anytime.',
  payamentMethodProceedWithPayment: 'Proceed with payment',
  payamentMethodContinueWithoutPaymentBtn: 'Continue to platform',
  payamentMethodCancelPaymentBtn: 'Cancel payment',

  // Ace - no plan popup
  startJourney: 'Check out our plan options at anytime and join the funded traders.',
  nowYouFamiliarPlatform: 'Now that you are familiar with the platform choose a plan that suits you best',
  nowYouFamiliarPlatformProTrader: 'Now that you are familiar with the platform choose a plan and prove yourself as a Pro Trader with massive capital!',
  welcomeReadyForRealDeal: 'Welcome, @@1. Ready for the real deal?',

  // Ace - dashboard
  plan: 'Plan',
  realizedPnl: 'Realized PnL',
  totalPnl: 'Total PnL',
  maxLoss: 'Max Loss',
  expiresIn: 'Expires in',
  maxDrawdown: 'Max Drawdown',
  maxDrawdownDescription: 'Total combined realized and unrealized loss. If the limit is hit, the plan is marked as failed and all positions will close automatically.',
  dailyLossDescription: 'Total daily PnL (realized and unrealized). If the loss limit is hit, all active positions will close automatically, and trading will be suspended until the next day.',
  consistencyRuleDescription: 'Measures how well-distributed your profits are. It calculates your total gains minus the impact of your single largest trade. To pass your objective, you must maintain a ',
  consistencyRuleScoreOfAtLeast75: 'Consistency Score of at least @@1.',
  tradingDaysDescription: 'The total number of days on which at least one trade was executed.',
  performance: 'Performance',
  availableBp: 'Available BP',
  active: 'Active',
  expired: 'Expired',
  target: 'Target',
  consistencyRule: 'Consistency Rule',
  tradingDays: 'Trading Days',
  reviewingDocuments: 'Performance and document review pending',
  reviewingDocumentsDescription: 'This may take up to one business day. We will get back to you when we are ready',
  rewindingTradingDay: 'Hold tight! We\'re rewinding your trading day. It should be ready in a few minutes',
  fundedPhaseAccountSetUp: 'Your @@1 account is being set up. We will let you know when it\'s ready.',
  tradingDayRewindModalTitle: 'Trading day has been rewound',
  tradingDayRewindModalDescription: 'Your daily loss is set to zero and buying power is restored. Continue trading and reach your goals',

  // Payouts
  commonPayoutsTitle: 'Payouts',
  commonPayout: 'Payout',
  potentialPayout: 'Potential Payout',
  availableCash: 'Available Cash',
  minimumCryptoAmount: '@@1 minimum amount',
  minimumBankAmount: '@@1 minimum amount',
  consistencyRuleBelow70: 'Consistency rule below 70%.',
  profitSplitReduced: 'Profit split reduced to 50%.',
  payoutHistory: 'Payout History',
  haventMadePayout: 'You haven\'t made a payout yet',
  payoutRules: 'Payout Rules',
  initiatingWithdrawal: 'Initiating Withdrawal',
  firstPayoutRule: '• Payout is equal to your account cash balance + 80% of the realized profit',
  secondPayoutRule: '• You can request a withdrawal 14 days after your first trade.',
  thirdPayoutRule: '• Minimum withdrawal: @@1 (1% of your plan\'s buying power).',
  fourthPayoutRule: '• Requests allowed only when market is closed.',
  fifthPayoutRule: '• Consistency rule above 50% is required to initiate a withdrawal.',
  afterRequest: 'After Request',
  sixthPayoutRule: '• After a withdrawal request, trading is locked for up to 24 hours (business days only) for compliance checks.',
  seventhPayoutRule: '• Payouts are processed on the 1st and 3rd Friday of each month.',
  eighthPayoutRule: '• Ace Trade will withdraw its split from your profit',
  payoutsNotAvailableWithdrawals: 'Withdrawals will be available once your account progresses to the Funded Phase',
  noMatchesDateRange: 'No matches found for this date range.',
  consistencyRuleWarning: 'Consistency Rule Warning',

  // Payouts Methods
  payoutsSelectMethod: 'Select payout method',
  payoutsSelectMethodDesc: 'Choose how you\'d like to get paid to continue',
  payoutsBankTransfer: 'Bank Transfer',
  payoutsCrypto: 'Crypto',
  payoutsUsdtSolata: 'In USDT via Solana • ',
  payoutsUpToBusinessDays: 'Up to @@1 business days',
  payoutsAddCryptoTitle: 'Enter your Public address',
  payoutsAddCryptoDescription: 'Please enter your Crypto wallet\'s public address for us to link it to your account. Verification may take up to one business day.',
  payoutsAddCryptoInputLabel: 'Your Crypto Wallet',
  payoutsAddCryptoInputPlaceholder: 'Enter your crypto wallet',
  payoutsAddCryptoConfirmBtn: 'Confirm Wallet',
  payoutsAddCryptoFootnote: 'Make sure your wallet supports USDT via Solana network',
  payoutsAddCryptoInvalidAddress: 'Invalid Crypto Wallet',
  payoutsAddCryptoSuccessTitle: 'Crypto wallet has been added!',
  payoutsAddCryptoSuccessDescription1: 'Verification may take up to 1 business day.',
  payoutsAddCryptoSuccessDescription2: 'You can proceed with your withdrawals comfortably.',

  // Plan Details
  demoPlanDetails: 'Demo Plan Details',
  planDetailsSubtitle: 'See all the rules and objectives for your selected plan in all progression stages. For all rules and requirements, see further details',
  loadingPlanDetails: 'Loading plan details...',
  autoPassIsActivated: 'Auto Scale is activated',
  autoPassNotActivated: 'Auto Scale is not activated',
  autoPassActivateDescription: 'Activate Auto Scale to automatically progress through challenges and unlock premium features with enhanced risk management.',
  activateAutoPass: 'Activate Auto Scale',
  deactivateAutoPass: 'Deactivate Auto Scale',
  currentStage: 'Current Stage',
  locked: 'Locked',
  buyingPower: 'Buying Power',
  profitShare: 'Profit Share',
  maxDailyLoss: 'Max Daily Loss',
  minTradingDays: 'Min. Trading Days',
  riskManagementRule: 'Risk Management Rule',
  notAvailable: 'N/A',

  deactivateAutoPassModalTitle: 'Are you sure you want to deactivate your Auto Scale?',
  deactivateAutoPassModalDescription: 'By deactivating the Auto Scale you will not move to the next funded step even if you reach all your objevtives.',
  deactivateAutoPassButton: 'Deactivate for $@@1',
  autoPassActivated: 'Auto Scale is activated',
  autoPassDeactivated: 'Auto Scale Deactivated',
  wantToActivateAutoPass: 'Want to activate your Auto Scale?',
  automaticTransitionText: 'Auto Scale automatically moves you through Funded stages. Upon transition a up to 10% of your account size in profit will carry over to the next stage. The 70/30 profit split will be applied to this carried-over amount',
  automaticTransitionEnabled: 'Automatic transition between all Funded stages is now enabled',
  reactivateAutoPassText: 'You can reactivate it at any time to move to the next stage',
  autoPassActivationFailedTitle: 'Something Went Wrong',
  autoPassActivationFailedText: 'Auto Scale Activation was unsuccessful. If the issue persists, contact us at ',

  // Choose Plan screen - filters
  accountSize: 'Account Size',
  autoPass: 'Auto Scale',
  getFunded: 'Get Funded',
  noTradingPlansAvailable: 'No plans available for the selected configuration.',
  rules: 'Rules',

  // Crypto Payment screen
  cryptoPaymentTitle: 'Make your Payment',
  cryptoPaymentQrDescription: 'Scan the QR code with your crypto app or copy the payment link bellow.',
  cryptoPaymentQrDescriptionMobile: 'Copy the payment link bellow in your crypto wallet app. ',
  cryptoPaymentPaymentLinkLabel: 'Payment Link',
  cryptoPaymentManualTitle: 'Manual Payment',
  cryptoPaymentManualDescription: "If your wallet doesn't support payment links use the details below. Ensure the network is set to Solana and the token is set to USDT.",
  cryptoPaymentSendAmountLabel: 'Send this amount',
  cryptoPaymentUsdtSuffix: 'USDT',
  cryptoPaymentUsdtRate: '1 USDT = @@1 USD',
  cryptoPaymentToAddressLabel: 'To this address',
  cryptoPaymentMemoLabel: 'Memo/Reference:',
  cryptoPaymentMemoInfo: "Use the exact memo/reference as shown. It's required for automatic processing of your payment.",
  cryptoPaymentSelectedPlanTitle: 'Selected Plan',
  paymentMethodAutoScaleTitle: 'Auto Scale',
  cryptoPaymentPlanPriceLabel: 'Plan Price',
  cryptoPaymentPlanPriceSuffix: 'one time fee',
  cryptoPaymentAutoPassActive: 'Active',
  cryptoPaymentAutoPassInactive: 'Inactive',
  paymentMethodSelectedPlanHaveCouponCode: 'Have a coupon code?',
  paymentMethodSelectedPlanCouponPlaceholder: 'Coupon code',
  paymentMethodSelectedPlanApply: 'Apply',
  paymentMethodSelectedPlanRemoveCoupon: 'Remove',
  paymentMethodSelectedPlanDiscountApplied: 'Discount applied',
  paymentMethodSelectedPlanCouponApplied: '@@1 Applied',
  paymentMethodCouponErrorNotFound: 'Invalid coupon code',
  paymentMethodCouponErrorExpired: 'This coupon has expired',
  paymentMethodCouponErrorInactive: 'This coupon is no longer active',
  paymentMethodCouponErrorPlanNotEligible: 'Coupon not valid for this plan',
  paymentMethodCouponErrorPurchaseNotEligible: 'Coupon not valid for this purchase',
  paymentMethodCouponErrorUserNotEligible: 'Coupon not valid for your account',
  paymentMethodCouponErrorUsageCapExceeded: 'This coupon is fully redeemed',
  paymentMethodCouponErrorRateLimited: 'Too many attempts. Try again later',
  paymentMethodCouponErrorRefresh: 'Please refresh and try again',
  paymentMethodCouponErrorDefault: "Couldn't apply coupon. Try again",
  paymentMethodSelectedPlanGetFreePlan: 'Get your free plan',
  cryptoPaymentCopyPaymentLinkAriaLabel: 'Copy payment link',
  cryptoPaymentCopyAddressAriaLabel: 'Copy address',
  cryptoPaymentCopyMemoAriaLabel: 'Copy memo reference',
  cryptoPaymentConfirmPayment: 'Confirm Payment',
  cryptoPaymentModalTitle: 'Made your Payment?',
  cryptoPaymentModalDescription: 'We\'ve sent you an email with the payment reference, please make sure to complete the payment by 24 hours.',
  cryptoPaymentModalDescription2: 'If you\'ve made your payment, continue to the  platform and await your plan activation.',
  cryptoPaymentQuickPaymentTitle: 'Quick Payment',
  cryptoPaymentQrCodeMessage: 'QR code and payment details are valid for 24 hours.',
  awaitingPaymentNotificationText: 'Your account is awaiting payment. We will let you know when the transfer is confirmed and you\'re ready to trade.',
  awaitingPaymentNotificationText2: 'Your account is awaiting payment. Daily loss will be reset once payment is confirmed.',
  awaitingPaymentNotificationText3: 'Your account is awaiting payment. We will deactivate Auto Scale once payment is confirmed.',
  cryptoPaymentDailyLossRewindTitle: 'Daily Loss Rewind',
  cryptoPaymentDailyDeactivateAutoScaleTitle: 'Deactivate Auto Scale',
  cryptoPaymentTotalPrice: 'Total Price',

  // Crypto Payout screen
  cryptoPayoutExchangeRate: '@@1 to @@2: 1:@@3',
  cryptoPaymentUnsuccessfulPaymentTitle: 'Plan payment unsuccessful',
  cryptoPaymentUnsuccessfulPaymentTitle2: 'DailyLoss payment unsuccessful',
  cryptoPaymentUnsuccessfulPaymentDescription: 'Please try making your payment again or contact our support team for more details.',

  // Referrals
  referralsTitle: 'Referrals',
  referralsSubtitle: 'Share your referral link, track registrations and purchases, monitor commissions, and request payouts.',
  referralsYourCode: 'Your referral code',
  referralsShareYourLink: 'Share your link',
  referralsShare: 'Share',
  referralsCopyLink: 'Copy referral link',
  referralsRegistrations: 'Registrations',
  referralsPurchases: 'Purchases',
  referralsBalance: 'Balance',
  referralsBalanceUnpaid: 'Unpaid',
  referralsBalanceRequested: 'Requested',
  referralsBalancePaid: 'Paid',
  referralsRequestPayout: 'Request payout',
  referralsRequestPayoutAmount: 'Request payout \u00b7 @@1',
  referralsMinimumPayout: 'Minimum payout: @@1',
  referralsTabReferrals: 'Referrals',
  referralsTabCommissions: 'Commissions',
  referralsLoadMore: 'Load More',
  referralsColumnUser: 'User',
  referralsColumnRegistered: 'Registered',
  referralsColumnCommission: 'Commission',
  referralsColumnStatus: 'Status',
  referralsColumnReferral: 'Referral',
  referralsColumnRequestId: 'Request ID',
  referralsColumnStatusChange: 'Status Change',
  referralsGroupRegistered: 'Registered @@1',
  referralsStatusPurchased: 'Purchased',
  referralsStatusNotPurchased: 'Not Purchased',
  referralsStatusAvailable: 'Available',
  referralsStatusRequested: 'Requested',
  referralsStatusPaid: 'Paid',
  referralsStatusRejected: 'Rejected',
  referralsEmptyReferralsTitle: 'No referrals yet.',
  referralsEmptyReferralsDescription: 'Share your referral link to start tracking registrations and purchases.',
  referralsEmptyCommissionsTitle: 'No commissions yet.',
  referralsEmptyCommissionsDescription: 'Commission entries will appear here after referred users complete eligible purchases.',
  referralsShareModalTitle: 'Share your link or QR code',
  referralsShareModalSubtitle: 'Invite friends to ACE Trade and earn rewards.',
  referralsShareModalSocialLabel: 'Share your referral link through:',
  referralsShareModalShareLink: 'Share Link',
  referralsShareViaFacebook: 'Share on Facebook',
  referralsShareViaX: 'Share on X',
  referralsShareViaLinkedin: 'Share on LinkedIn',
  referralsShareViaWhatsapp: 'Share on WhatsApp',
  referralsPayoutConfirmTitle: 'Confirm payout request',
  referralsPayoutConfirmDescription: 'You\u2019re requesting a payout of @@1, which includes your full unpaid balance. We\u2019ll contact you by email with updates.',
  referralsPayoutConfirm: 'Confirm',
  referralsPayoutCancel: 'Cancel',
  referralsPayoutSubmittedTitle: 'Payout request submitted!',
  referralsPayoutSubmittedDescription: 'We received your payout request for @@1.\nWe\u2019ll contact you by email with updates.',
  referralsPayoutDone: 'Done',
  referralsPayoutFailedTitle: 'Payout request failed',
  referralsPayoutFailedDescription: 'We couldn\'t submit your payout request for @@1. If the issue persists, please contact our support.',
  referralsLockedTitle: 'Buy your first Challenge. Unlock your referral link.',
  referralsLockedDescription: 'Start referring traders and earn 10%\nof their first Challenge.',
  referralsLockedStartChallenge: 'Start a Challenge',
  referralsLockedLearnMore: 'Learn More',
  referralsPendingAccountTitle: 'When account is activated find your referral code',
  referralsPendingAccountCode: 'HERE',
  referralsPendingShareYourLink: 'You will be able to share your own link:',
  referralsPendingLinkPlaceholder: 'Your/link/here',
};
